import { useEffect } from "react";
import { useQuery } from "react-query";
import { useSetState } from "react-use";
import { getAvailableMemberships } from "../services/membership";
import { MembershipType } from "../types/airgraft";

type Options = {
  context?: string;
};

// export default function useAvailableMemberships(
//   options?: Options
// ): [MembershipType[], boolean, Error] {
//   const [state, setState] = useSetState<{
//     memberships: MembershipType[];
//     isLoading: boolean;
//     error: Error;
//   }>({ memberships: null, isLoading: true, error: null });

//   useEffect(() => {
//     async function loadMemberships() {
//       setState({ isLoading: true });
//       try {
//         const memberships = await getAvailableMemberships({
//           context: options?.context
//         });
//         setState({ memberships, isLoading: false, error: null });
//       } catch (e) {
//         setState({ memberships: null, isLoading: false, error: e });
//       }
//     }
//     if (!state.memberships) {
//       loadMemberships();
//     }
//   }, []);

//   return [state.memberships, state.isLoading, state.error];
// }

export default function useAvailableMemberships() {
  return useQuery("available-memberships", () => getAvailableMemberships(), {
    staleTime: 1000 * 60 // 60 Seconds
  });
}
